import React, {Component} from 'react';
import couterpart from 'counterpart';
import {ToastsContainer, ToastsStore} from 'react-toasts';

import {TiArrowBackOutline} from 'react-icons/ti';

import MenuComponent2 from './MenuComponent2';
import WorkOrderDataService from '../services/WorkOrderDataService';
// import WorkOrderAdditions from './WorkOrderAdditions';
import WorkOrderImages from './WorkOrderImages';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import AuthenticationService from '../services/AuthenticationService';
import NoteDataService from '../services/NoteDataService';
import WorkOrderButtons from './WorkOrderButtons';
import UserDataService from '../services/UserDataService';
// import ItemDetailsViewById from './ItemDetailsViewById';
// import TalkDetails from './TalkDetails';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';

import '../css/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import { ICON_COLOR } from '../icon';

class ShipWorkOrderDetails extends Component {
    constructor() {
        super();
        this.state = {
            workOrder: {},
            workOrderId: null,
            updated: false,
            options: "",
            selectedOption: null,
            startDate: null,
            endDate: null
        };
    };

    componentDidMount () {
        const { id } = this.props.match.params;
        WorkOrderDataService.retrieveById(`${id}`).then(data => {
            this.setState({ 
                workOrderId: id,
                workOrder:  data
            });
            
        });

        NoteDataService.retrieveNotesByWorkOrder(id).then(data =>{
            this.setState({ 
                notes: data
            }); 
        });        

        if (AuthenticationService.isAdmin()){
            UserDataService.retrieveWorkers().then(data => {
                var len = data.length;
                var selectOptions = [];
                for(var i=0; i<len; i++){
                    selectOptions.push({key:data[i].id, label: data[i].firstName + data[i].lastName, value: data[i].id})
                }
                this.setState({selectOptions: selectOptions});
            });
        }

    }

    handleUpdate (){
        this.setState({
            updated: true
        });  
    }

    handleQtyChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              qty: newValue                  
            }
        }));        
    }

    handleUrgentChange(e){
        var newValue = e.target.checked? 1: 0;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              urgent: newValue                  
            }
        }));        
    }

    handleWorkerChange(e){
        var newValue = e.target.value.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              worker: newValue                  
            }
        }));        
    }

    handleCustomerNoteChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              notesFromBuyer: newValue                  
            }
        }));        
    }

    handleSpecialNoteChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              notesInternal: newValue                   
            }
        }));
    }

    handleSelectChange(e){
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        //var dd2 = String(today.getDate() + 2).padStart(2, '0');
        var MM= String(today.getMonth() + 1).padStart(2, '0'); 
        var yyyy = today.getFullYear();

        today = yyyy + '/' + MM + '/' + dd;
        //var endDate = yyyy + '/' + MM + '/' + dd2;
        var value = e.target[e.target.selectedIndex].value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              worker: value,
              startDate: today//, 
              //endDate: endDate                   
            }
        }));
    };

    handleEndDateChange(date){
        var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              endDate: sDate                   
            }
        }));
    }

    saveInfo(e){
        WorkOrderDataService.updateWorkOrder(this.state.workOrder).then(data => {
            var msg = couterpart.translate("msg_saved_info");
            if (data.message === undefined){
                if (data.ret < 1){
                    msg = couterpart.translate("msg_saved_error");
                }
            }else{
                msg = couterpart.translate("msg_saved_error");
            }
            ToastsStore.error(msg);
        });
    }

    cloneInfo(e){
        WorkOrderDataService.cloneWorkOrder(this.state.workOrder).then(data => {
            var msg = couterpart.translate("msg_clone_info");
            if (data.message === undefined){
                if (data.id < 1){
                    msg = couterpart.translate("msg_clone_error");
                }
            }else{
                msg = couterpart.translate("msg_clone_error");
            }
            ToastsStore.error(msg);
        });
    }

    renderOption(option){
        return (
            <option key={option.key} value={option.value}>{option.label}</option>
        );
    }

    renderWorkerByRole(){
        if (!AuthenticationService.isAdmin()){
            return (<label>{this.state.workOrder.workerFullName}</label>);
        }

        if((this.state.selectOptions ===undefined) || (this.state.selectOptions === null)){
            return (<></>);
        }
        return(
        <select defaultValue={this.state.workOrder.worker} onChange={this.handleSelectChange.bind(this)}>
        {this.state.selectOptions !== undefined && this.state.selectOptions.map(option =>this.renderOption(option))}
        </select>
        );
    }

    renderEditButtons(){
        if (!AuthenticationService.isAdmin() && !AuthenticationService.isService()){
            return (<></>);
        }

        const button_save = couterpart.translate('button_save');
        const button_clone = couterpart.translate('button_clone');
        if (AuthenticationService.isAdmin()){
            return(
                <tr>
                    <td colSpan="4">
                        <button className="myButton" type="button" 
                        onClick={this.saveInfo.bind(this)}>{button_save}</button>
                    </td>
                </tr>
            );
        }else{
            return(
            <tr>
                <td colSpan="4">
                    <button className="myButton" type="button" 
                    onClick={this.saveInfo.bind(this)}>{button_save}</button>&nbsp;&nbsp;
                    <button className="myButton" type="button" 
                    onClick={this.cloneInfo.bind(this)}>{button_clone}</button>
                </td>
            </tr>
            );  
        }     
    }

    getOrderNote(note){
        let idx = note.indexOf('order_note');
        if (idx >= 0){
            let orderNote = note.substring(idx);
            let idx2 = orderNote.indexOf('->');
            if (idx2 >= 0){
                let s = orderNote.substring(idx2)
                let idx3 = s.indexOf('\n\r  ');
                if (idx3 >= 0){
                    return orderNote.substring(0, idx2 + idx3)
                }
                return orderNote
            }
            return orderNote;
        }
        return ''
    }

    renderNotes(){
        if (this.state.notes === undefined){
            return "";
        }

        let s = "";
        for(let i=0; i< this.state.notes.length; i++){
            s += this.getOrderNote(this.state.notes[i].note) + "\r\n";
        }
        return s;
    }    

    backToList(){
        this.props.history.push("/workOrders");
    }
      
    render() {
        if (!AuthenticationService.isAdmin() && 
            !AuthenticationService.isService() && 
            !AuthenticationService.isKhac() &&
            !AuthenticationService.isShipping() &&
            !AuthenticationService.isDesigner()){
            return (<div>Unauthorized access.</div>);
        }

        if (this.state.workOrderId === null){
            return (<></>);
        }

        //const { selectedOption } = this.state.selectedOption;
        if (this.state.workOrder.workOrderNo !== undefined){
            return (
                <div>
                <MenuComponent2/>
                <ToastsContainer store={ToastsStore} position="bottom_center" />
                <div style={{padding:"5px"}}>
                <button className="myButton" onClick={this.backToList.bind(this)}>
                        <TiArrowBackOutline color={ICON_COLOR}/>&nbsp;
                        {couterpart.translate('button_back')}&nbsp;&nbsp;&nbsp;&nbsp;</button>
                </div>
                <div className="row">
                    <div className="col-8">
                        <div className="row">
                            <div className="col-3 border-top border-left border-light-gray">
                                <div className="row"><img alt="" src={"data:image/gif;base64," + this.state.workOrder.qrCode}/></div>
                                <div className="row">{this.state.workOrder.workOrderNo}</div>
                            </div>
                            <div className="col-7 border-top border-left border-light-gray">
                                <div className="row border-bottom border-light-gray">                    
                                    <div className="col"><b>{ couterpart.translate('work_order_order_date_s') }</b></div>
                                    <div className="col border-left border-right border-light-gray">{WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.state.workOrder.orderDate)}</div>
                                </div>
                                <div className="row border-bottom border-light-gray">                    
                                    <div className="col"><b>{ couterpart.translate('work_order_leadTimeProduction') }</b></div>
                                    <div className="col border-left border-right border-light-gray">{WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.state.workOrder.leadTimeProduction)}</div>
                                </div>
                                <div className="row border-bottom border-light-gray">                    
                                    <div className="col"><b>{ couterpart.translate('work_order_worker') }</b></div>
                                    <div className="col border-left border-right border-light-gray">{this.renderWorkerByRole()}</div>
                                </div>
                                <div className="row border-bottom border-light-gray">                    
                                    <div className="col"><b>{couterpart.translate('work_order_start_date')}</b></div>
                                    <div className="col border-left border-right border-light-gray">{WorkOrderUtil.formatDisplayDateMMddyyyy(this.state.workOrder.startDate)}</div>
                                </div>
                                <div className="row border-bottom border-light-gray">                    
                                    <div className="col"><b>{couterpart.translate('work_order_end_date')}</b></div>
                                    <div className="col border-left border-right border-light-gray">{this.state.workOrder.endDate}</div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_code')}</b></div>
                            <div className="col-3 border-top border-left border-light-gray">{this.state.workOrder.sku}</div>
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('shop_pcode')}</b></div>
                            <div className="col-3 border-top border-left border-light-gray">{this.state.workOrder.fullPCode}</div>
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_color')}</b></div>
                            <div className="col-1 border-top border-left border-right border-light-gray">{this.state.workOrder.colorMaterial}</div>
                        </div>
                        <div className="row">
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_type')}</b></div>
                            <div className="col-3 border-top border-left border-light-gray">{this.state.workOrder.shapeDesign}</div>
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_quantity_s')}</b></div>
                            <div className="col-2 border-top border-left border-light-gray">{this.state.workOrder.qty}</div>
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_size')}</b></div>
                            <div className="col-2 border-top border-left border-right border-light-gray">{this.state.workOrder.lengthSize}</div>
                        </div>
                        <div className="row">
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_font')}</b></div>
                            <div className="col-2 border-top border-left border-right border-light-gray"><pre>{this.state.workOrder.font}</pre></div>
                            <div className="col-2 border-top border-left border-light-gray">
                                <label className="labelBox">{couterpart.translate('work_order_customer_s')}</label>
                            </div>
                            <div className="col-5 border-top border-left border-light-gray">
                                <label className="labelValueBox">{this.state.workOrder.customer}</label>
                            </div>
                        </div>                        
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_personalization')}</b></div>
                            <div className="col-8 border-top border-left border-right border-light-gray"><pre>{this.state.workOrder.personalization}</pre></div>
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_special_note')}</b></div>
                            <div className="col-8 border-top border-left border-right border-light-gray">{this.state.workOrder.notesInternal}</div>
                        </div>
                        <div className="row">
                            <div className="col-10 border-top border-left border-right border-light-gray"><br/>
                                <WorkOrderImages mode="MODE_EDIT"  workOrderId={this.state.workOrderId} 
                                    isUpdated={this.state.updated}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-10 border-top border-left border-right border-light-gray">
                            {this.state.workOrder.statusName}
                                <br/>
                                <WorkOrderButtons workOrderId={this.state.workOrderId}
                                        orderId={this.state.workOrder.orderInfoId} 
                                        workCardId={this.state.workOrder.workCardId}
                                        currentStatus = { this.state.workOrder.status }/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-10 border-top border-bottom border-left border-right border-light-gray">
                                <br/>
                                <ExpansionPanel>
                                    <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    >
                                    <Typography>{couterpart.translate('label_note')}</Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        <pre className="note-items">
                                            { this.renderNotes() }
                                        </pre>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                <br/>
                            </div>                       
                        </div>                                                                                                                                                 
                    </div>
                    {/* <div className="col-4">
                        <div className="row">
                        <WorkOrderAdditions mode="MODE_EDIT" caption={couterpart.translate('work_order_additions')} 
                            workOrderId={this.state.workOrderId} 
                            isUpdated={this.state.updated}/> 
                        </div>                       
                        <div className="row"><ItemDetailsViewById itemSku={this.state.workOrder.sku}/></div>
                        <div className="row">&nbsp;</div>
                        <div className="row">{ this.state.workOrder.store }
                            <TalkDetails workOrderId={this.state.workOrderId} sender="designer" workingShop={ this.state.workOrder.store } />
                        </div>                         
                    </div> */}
                </div>
            </div>
            );
        }else{
            return (<div>&nbsp;</div>)
        }
    }
}

export default ShipWorkOrderDetails;